import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-center" }

import SfxChip from "src/components/data-point/SfxChip.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { WorkOrderStateTableRowElement } from "src/util/types/components/sfxTable"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTdWorkOrderState',
  props: {
  state: {
    type: String as PropType<WorkOrderStateTableRowElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const stateChipData = computed(() => {
  switch (props.state) {
    case "overdue":
      return {
        label: t("sfxTable.state_overdue"),
        color: "negative",
        icon: Icons.WARNING,
      }
    case "behind":
      return {
        label: t("sfxTable.state_behind"),
        color: "warning",
        icon: Icons.BEHIND,
      }
    case "resource":
      return {
        label: t("sfxTable.state_resource"),
        color: "fun-label-and-icon",
        icon: Icons.WORK_ORDER_RESOURCE,
      }
    case "draft":
      return {
        label: t("sfxTable.state_draft"),
        color: "disabled-back",
      }
    case "in_progress":
      return {
        label: t("sfxTable.state_in_progress"),
        color: "fun-label-and-icon",
      }
    case "open":
      return {
        label: t("sfxTable.state_open"),
        color: "fun-label-and-icon",
      }
    case "complete":
      return {
        label: t("sfxTable.state_complete"),
        color: "positive",
        icon: Icons.WORK_ORDER_COMPLETED,
      }
    case "planned":
      return {
        label: t("sfxTable.state_planned"),
        color: "fun-label-and-icon",
      }
    case "complete_closed":
      return {
        label: t("sfxTable.state_closed"),
        color: "blue-900",
        icon: Icons.WORK_ORDER_COMPLETED,
      }
    case "closed":
      return {
        label: t("sfxTable.state_closed"),
        color: "inactive",
        icon: Icons.WORK_ORDER_CLOSED_UNCOMPLETED,
      }
    default:
      return {
        label: t("sfxTable.state_unknown"),
        color: "disabled-back",
      }
  }
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createBlock(_component_q_td, { class: "sfx-table__td" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SfxChip, {
          label: stateChipData.value.label,
          color: stateChipData.value.color,
          "icon-right": stateChipData.value.icon,
          "text-color": "white"
        }, null, 8, ["label", "color", "icon-right"])
      ])
    ]),
    _: 1
  }))
}
}

})